<template>
  <div class="groupProductListPage">
      <mu-appbar class="head">
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>        
        <p class="title">拼团</p>
        <mu-icon-menu icon=":fa fa-more" slot="right">
          <mu-menu-item to="/usercenter/index" title="个人中心"/>
          <mu-menu-item to="/" title="首页"/>
          <mu-menu-item to="/retail/cart" title="购物车"/>
        </mu-icon-menu>
      </mu-appbar>
    <v-scrollEvent :on-refresh="onRefresh" :on-infinite="onInfinite"  ref="scroll">
      <mu-list v-if="activityInfo">
        <div class="list_item" v-if="activityInfo" :key="activityInfo.Fid">
          <div class="itemTop">
            <div class="itemTitle">
              <p class="activeName">{{activityInfo.Fname}}</p> 
              <p class="time">{{pintuanStatus}} <span>{{activityInfo.FremainingTime}}</span> </p>
            </div>
            <div class="topRight" v-if="activityInfo.FcountJoinGroup>0">
              <p class="peopleCount">{{activityInfo.FcountJoinGroup}}人正在拼</p>
              <mu-avatar :src="headItem" class="zindexOne" slot="leftAvatar" v-for="(headItem,index) in activityInfo.FUserHeadList" :key="index" />                 
            </div>
          </div>
          <div class="product" v-if="activityProductList">
            <mu-list-item class="product_item" v-for="proItem in activityProductList" :key="proItem.Fid">                   
              <img :src="proItem.ImagePath" class="proImg" alt=""> 
              <div class="product_info" :style="{width: proItemInfoWidth +'px'}">
                  <div class="product_title">
                      <span class="slaePrice">{{proItem.ZheKou}}折</span>
                      <span class="prime_cost">指导价{{proItem.OldPrice}}元</span>
                      {{proItem.ProductName}}
                  </div>
                  <div class="sign">
                    <div class="shopNum sign">{{activityInfo.FgroupNumber}}人团</div>
                    <div class="free_post sign" v-if="!proItem.IsFreight">包邮</div>
                  </div> 
                  <div class="price_time">
                      <p class="price">拼团价<span>{{proItem.FminSkuPrice}}</span>元</p>
                      <p class="sellCount">已团{{proItem.FcountJoinGroup}}件</p>
                  </div>
                  <router-link v-if="overTime" :to="'/retail/productDetail?skuId='+proItem.FminSkuId+'&activityId='+activityInfo.Fid">
                    <div class="num_goshop">         
                        <mu-raised-button label="去拼团" class="demo-raised-button"/>                                 
                    </div>
                  </router-link>  
                  <router-link v-if="!overTime" :to="'/retail/productDetail?skuId='+proItem.FminSkuId">
                    <div class="num_goshop">         
                        <mu-raised-button label="去看看" class="demo-raised-button"/>                                 
                    </div>
                  </router-link>
              </div>
            </mu-list-item>
          </div>
        </div>
      </mu-list>
    </v-scrollEvent>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>
<script>
import siteconfig from '../../util/siteconfigCache'
export default {
  data() {
    return {
       proItemInfoWidth: (parseInt(document.documentElement.clientWidth)-137),
       loaded:false,
       pintuanStatus:'距离结束',
       activityInfo:{},
       activityProductList:[],
       page: 1,
       pageSize:10,
       pageEnd:0,
       overTime:true
    }
  },
  mounted() {
    this.GetActivityList(true)
    
  },
  methods: {  
    GoHistory(){
      this.$router.goBack()
    },

    GetActivityList(isNewSearch){ 
      this.$refs.XRtoast.load() 
      if(isNewSearch){     
        this.page = 1
      }
      else{
        this.page++
      }   

      var ths = this;   
      ths.$post(
        "/Shop/PinTuanServer/WapActivityGetListMore", {id: this.$route.query.id,page:this.page,pageSize:this.pageSize}
      ).then(function(res) {
        ths.loaded= false
        // ths.scrollDone()
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          ths.activityInfo = {}
          //ths.$refs.XRtoast.failed(res.Msg, true)
        }
        else{  
          ths.activityInfo = res.Data.info
          ths.calcPayOverDate(ths.activityInfo.FremainingTime)
          if(isNewSearch){
            ths.activityProductList = res.Data.list
          }else{                 
            for(var i=0; i< res.Data.list.length; i++){
              ths.activityProductList.push(res.Data.list[i])
            }
          }
          ths.pageEnd =  res.Data.total % ths.pageSize !=0 ? parseInt( res.Data.total / ths.pageSize)+1: res.Data.total/ ths.pageSize   
        }
      });
    },    
    calcPayOverDate(isEndtime){
      var hour = isEndtime.split(':')[0];
      var min = isEndtime.split(':')[1];
      var sec = isEndtime.split(':')[2];
      if(hour==0 && min==0 && sec==0){
        this.$refs.XRtoast.failed("该活动已结束",true)
        this.pintuanStatus = '已结束'
        this.overTime = false
      }
    },
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {
      this.scrollDone = done
      if(this.page+1 > this.pageEnd){
        this.$refs.XRtoast.failed("已经到底",true)
        this.$refs.scroll.infiniteDone()
        return
      }
      this.GetActivityList(false)
    },
  }
};
</script>
<style>
  .groupProductListPage{

  }
  .groupProductListPage .head p.title{
    text-align: center;
    font-size: 16px;
  }
  .groupProductListPage .mu-list{
    padding: 0;
  }
  .groupProductListPage .mu-list .list_item:first-child{
    margin: 0;
  }
  .groupProductListPage .mu-list .list_item{
    margin-top: 15px;
    background: #fff;
    padding: 15px 0;
  }
  .groupProductListPage .mu-list .list_item .itemTop{
    overflow: hidden;
    padding: 0 16px;
  }
  .groupProductListPage .mu-list .list_item .itemTop .itemTitle{
    float: left;
    font-size: 16px;
    width: 40%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 50px;
  }
  .groupProductListPage .mu-list .list_item .itemTop .itemTitle .activeName{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
  }
  .groupProductListPage .mu-list .list_item .itemTop .itemTitle .time{
    font-size: 12px;
    color: #999;
  }
  .groupProductListPage .mu-list .list_item .itemTop .itemTitle .time span{
    padding-left: 5px;
    color: #DEAAA7;
  }
  .groupProductListPage .mu-list .list_item .itemTop .topRight{
    float: right;
    display: flex;
    align-items: center;
    background: #FEF2F9;
    width: auto;
    padding: 0 5px;
    border-radius: 15px;
    position: relative;
    height: 30px;
    padding-right: 60px;
    margin-top: 5px;
  }
  .groupProductListPage .mu-list .list_item .itemTop .topRight .peopleCount{
    font-size: 14px;
    color: red;
    padding-right: 5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .groupProductListPage .mu-list .list_item .itemTop .topRight .mu-avatar{
    width: 23px;
    height: 23px;
    position: absolute;
    background: #fff;
    border-radius: 50%; 
    top: 3.5px;
  }
  .groupProductListPage .mu-list .list_item .itemTop .topRight .zindexOne:nth-child(2){
    right: 35px;
  }
   .groupProductListPage .mu-list .list_item .itemTop .topRight .zindexOne:nth-child(3){
    right: 20px;
  }
  .groupProductListPage .mu-list .list_item .itemTop .topRight .zindexOne:nth-child(4){
    right: 5px;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .proImg{
    width: 95px;
    float: left;
    background: white;
    height: 95px;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .product_info{
    float: right;
    margin-left: 10px;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .product_info .product_title{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 14px;
    color: #000;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .product_info .product_title .slaePrice{
    color: red;
    font-weight: bold;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .product_info .product_title .prime_cost{
    color: #666;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .product_info .sign{
    text-align: center;
    border-radius: 2px;
    color: #fff;
    font-size: 12px;
    padding: 1px 0;
    overflow: hidden;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .product_info .sign .shopNum{
    background: #EB4D54;
    width: 40px;
    border-radius: 5px;
    margin-right: 10px;
    float: left;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .product_info .sign .free_post{
    float: left;
    width: 30px;
    border-radius: 5px;
    margin-right: 10px;
    background: #CC9137;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .product_info .price_time{
    float: left;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .product_info .num_goshop{
    float: right;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .product_info .price_time .price{
    color: #C13B38;
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    margin-top: 11px;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .product_info .price_time .price span{
    font-size: 20px;
    padding: 0 5px;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .product_info .price_time .sellCount{
    font-size: 14px;
    color: #999;
    text-align: left;
  }
  .groupProductListPage .mu-list .list_item .product .product_item .product_info .num_goshop .mu-raised-button{
    min-width: 60px;
    height: 25px;
    margin-top: 13px;
    background: #C13B38;
    color: #fff;
  }
</style>




// WEBPACK FOOTER //
// src/pages/groupShop/groupProductList.vue